"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3372],{

/***/ 63372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PN": function() { return /* binding */ TileSelectorApi; },
  "hz": function() { return /* binding */ contactUs; },
  "NL": function() { return /* binding */ getAwardsAndAccolades; },
  "pQ": function() { return /* binding */ getBoardOfDirectorsData; },
  "QR": function() { return /* binding */ getCsrGallery; },
  "JJ": function() { return /* binding */ getIntouch; },
  "hc": function() { return /* binding */ getLeadershipTeamData; },
  "mY": function() { return /* binding */ getPremiumSalesListing; },
  "mq": function() { return /* binding */ requestCallback; },
  "SM": function() { return /* binding */ requestQuote; },
  "y1": function() { return /* binding */ savePincode; },
  "lp": function() { return /* binding */ scheduleMeeting; }
});

// UNUSED EXPORTS: GetCmsPages, GetPlaceDetailsByUrlKey, GetProductsOnStorePage, GetStoreData, getInvestors, getLatestNews, getMedia, getNonObtb, getProductDetailsBySkuQuery, getStatesCities, storeLocatorSendSms, urlResolver, viewAnnoucement, viewPressRelease

// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(31230);
;// CONCATENATED MODULE: ./gql/others.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation request_callback(\n    $name: String!\n    $phone: String!\n    $page_url: String\n    $First_Visited_URL: String\n    $pincode: String\n    $email: String\n    $User_Device: String\n    $User_Browser: String\n  ) {\n    request_callback(\n      name: $name\n      phone: $phone\n      page_url: $page_url\n      First_Visited_URL: $First_Visited_URL\n      pincode: $pincode\n      email: $email\n      user_device: $User_Device\n      browser: $User_Browser\n    ) {\n      status\n      msg\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation get_in_touch(\n    $name: String!\n    $phone: String!\n    $pincode: String\n    $email: String\n    $page_url: String\n    $First_Visited_URL: String\n    $call_id: String\n    $User_Device: String\n    $User_Browser: String\n    $customer_type: String\n  ) {\n    get_in_touch(\n      name: $name\n      phone: $phone\n      pincode: $pincode\n      email: $email\n      page_url: $page_url\n      First_Visited_URL: $First_Visited_URL\n      call_id: $call_id\n      user_device: $User_Device\n      browser: $User_Browser\n      customer_type: $customer_type\n    ) {\n      status\n      msg\n      lead_id\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation request_price_quote(\n    $name: String!\n    $phone: String!\n    $iama: String!\n    $email: String!\n    $areatobetiled: String!\n    $address1: String!\n    $address2: String!\n    $state: String!\n    $city: String!\n    $productid: String!\n    $pincode: String!\n    $page_url: String!\n    $First_Visited_URL: String\n    $User_Device: String\n    $User_Browser: String\n  ) {\n    request_price_quote(\n      name: $name\n      phone: $phone\n      iama: $iama\n      email: $email\n      areatobetiled: $areatobetiled\n      address1: $address1\n      address2: $address2\n      state: $state\n      city: $city\n      productid: $productid\n      pincode: $pincode\n      page_url: $page_url\n      First_Visited_URL: $First_Visited_URL\n      user_device: $User_Device\n      browser: $User_Browser\n    ) {\n      status\n      msg\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  {\n    investor_page_v1 {\n      section {\n        section_name\n        title {\n          title_name\n          financial_year {\n            fytitle\n            fyfile {\n              file_url\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query getCmsPage($identifier: String!) {\n    cmsPage(identifier: $identifier) {\n      identifier\n      url_key\n      title\n      content\n      content_heading\n      page_layout\n      meta_title\n      meta_description\n      meta_keywords\n    }\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  {\n    press_release {\n      title\n      description\n      press_release {\n        img\n        postUrl\n        date\n        title\n      }\n      latest_announcement {\n        img\n        postUrl\n        date\n        title\n        atarget\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  {\n    latest_news {\n      title\n      description\n      latest_news {\n        img\n        postUrl\n        date\n        title\n        post_id\n        identifier\n        publish_time\n        thirdurl\n        content_heading\n        short_content\n        content\n        meta_keywords\n        meta_description\n      }\n      latest_announcement {\n        img\n        postUrl\n        date\n        title\n        atarget\n      }\n    }\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation (\n    $name: String!\n    $phone: String!\n    $email: String!\n    $state: String\n    $city: String\n    $subject: String!\n    $message: String!\n    $pageurl: String!\n    $First_Visited_URL: String\n    $country: String\n    $User_Device: String\n    $User_Browser: String\n  ) {\n    contact_us(\n      name: $name\n      phone: $phone\n      email: $email\n      state: $state\n      city: $city\n      subject: $subject\n      message: $message\n      pageurl: $pageurl\n      country: $country\n      First_Visited_URL: $First_Visited_URL\n      user_device: $User_Device\n      browser: $User_Browser\n    ) {\n      status\n      msg\n    }\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query viewPressRelease($identifier: String!) {\n    view_press_release(identifier: $identifier) {\n      img\n      postUrl\n      date\n      title\n      post_id\n      identifier\n      authors\n      content_heading\n      short_content\n      content\n      meta_keywords\n      meta_description\n    }\n  }\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query viewAnnouncement($identifier: String!) {\n    view_announcement(identifier: $identifier) {\n      img\n      postUrl\n      date\n      title\n      post_id\n      identifier\n      content_heading\n      short_content\n      content\n      meta_keywords\n      meta_description\n    }\n  }\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation (\n    $name: String!\n    $mobilenumber: String!\n    $email: String!\n    $store: String!\n    $datetimepicker_mask: String!\n    $youare: String!\n    $tilesrequirementfor: String!\n    $remarks: String!\n    $page_url: String!\n    $First_Visited_URL: String\n    $User_Device: String\n    $User_Browser: String\n  ) {\n    signature_company(\n      name: $name\n      mobilenumber: $mobilenumber\n      email: $email\n      store: $store\n      datetimepicker_mask: $datetimepicker_mask\n      youare: $youare\n      tilesrequirementfor: $tilesrequirementfor\n      remarks: $remarks\n      page_url: $page_url\n      First_Visited_URL: $First_Visited_URL\n      user_device: $User_Device\n      browser: $User_Browser\n    ) {\n      status\n      msg\n    }\n  }\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query getUrlResolver($url: String!) {\n    urlResolver(url: $url) {\n      entity_uid\n      relative_url\n      redirectCode\n      type\n    }\n  }\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query getAwardsAndAccolades {\n    awards_accolades {\n      year_awards {\n        year\n        awards {\n          imagetitle\n          imagealt\n          image\n          title\n          content\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query getCsrGallery {\n    csr_gallery {\n      type\n      src\n      title\n    }\n  }\n"
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query getBoardOfDirectorsData {\n    board_of_director {\n      image_src\n      image_alt\n      name\n      designation\n      details_initial\n      details_remaining\n    }\n  }\n"
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query getLeadershipTeamData {\n    executive_managers {\n      image_src\n      image_alt\n      name\n      designation\n      details_initial\n      details_remaining\n    }\n  }\n"
    ]);
    _templateObject15 = function() {
        return data;
    };
    return data;
}
function _templateObject16() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation showPremiumSalesProducts(\n    $location: String!\n    $size: String!\n    $row: String!\n    $page: String!\n    $sortby: String!\n  ) {\n    showPremiumSalesProducts(\n      location: $location\n      size: $size\n      row: $row\n      page: $page\n      sortby: $sortby\n    ) {\n      success\n      data\n      message\n    }\n  }\n"
    ]);
    _templateObject16 = function() {
        return data;
    };
    return data;
}
function _templateObject17() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SendStoreLocatorSms(\n    $name: String!\n    $mobileNumber: String!\n    $sid: Int!\n    $page_url: String!\n    $First_Visited_URL: String\n    $pincode: String\n    $User_Device: String\n    $User_Browser: String\n  ) {\n    sendStoreLocatorSms(\n      name: $name\n      mobileNumber: $mobileNumber\n      sid: $sid\n      page_url: $page_url\n      First_Visited_URL: $First_Visited_URL\n      pincode: $pincode\n      user_device: $User_Device\n      browser: $User_Browser\n    ) {\n      success\n      message\n    }\n  }\n"
    ]);
    _templateObject17 = function() {
        return data;
    };
    return data;
}
function _templateObject18() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation getTileSelector(\n    $ttype: String!\n    $mainattrib: String!\n    $etxraattrib: String!\n    $showcolor: String\n    $statevalauto: String\n    $colorval: String\n    $listproducts: String\n  ) {\n    getTileSelector(\n      ttype: $ttype\n      mainattrib: $mainattrib\n      etxraattrib: $etxraattrib\n      showcolor: $showcolor\n      statevalauto: $statevalauto\n      colorval: $colorval\n      listproducts: $listproducts\n    ) {\n      success\n      data\n      message\n    }\n  }\n"
    ]);
    _templateObject18 = function() {
        return data;
    };
    return data;
}
function _templateObject19() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation getProductDetailsBySku($sku: String!) {\n    getProductDetailsBySku(sku: $sku) {\n      success\n      data\n      message\n    }\n  }\n"
    ]);
    _templateObject19 = function() {
        return data;
    };
    return data;
}
function _templateObject20() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query {\n    getStates {\n      state\n      cities\n    }\n  }\n"
    ]);
    _templateObject20 = function() {
        return data;
    };
    return data;
}
function _templateObject21() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GetStoreData($filter: StoreDataFilterInput!) {\n    getStoreData(filter: $filter) {\n      obtbs {\n        id\n        client_store_id\n        actual_client_store_id\n        business_name\n        alternative_name\n        circle\n        address_1\n        address_2\n        locality\n        landmark\n        city\n        state\n        postcode\n        main_phone_no\n        gmaps_place_id\n        store_manager_phone_no\n        billed_in_history\n        longitude\n        latitude\n        distance\n        no_of_sales\n      }\n      nonObtbs {\n        entity_id\n        no\n        name\n        address\n        address_2\n        city\n        state_desc\n        gmaps_place_id\n        phone_no\n        email\n        customer_type\n        obtb_type\n        longitude\n        latitude\n        invoice_no\n        invoice_date\n        billed_in_history\n        created_at\n        updated_at\n        distance\n        no_of_sales\n      }\n      city_not_found\n      city_name\n    }\n  }\n"
    ]);
    _templateObject21 = function() {
        return data;
    };
    return data;
}
function _templateObject22() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query getNonObtbsByCpCode($cpcode: String!) {\n    getNonObtbsByCpCode(cpcode: $cpcode) {\n      entity_id\n      no\n      name\n      address\n      city\n      state_desc\n      phone_no\n      email\n      customer_type\n      obtb_type\n      longitude\n      latitude\n      invoice_no\n      invoice_date\n      created_at\n      updated_at\n    }\n  }\n"
    ]);
    _templateObject22 = function() {
        return data;
    };
    return data;
}
function _templateObject23() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GetPlaceDetailsByUrlKey($url_key: String!) {\n    getPlaceDetailsByUrlKey(url_key: $url_key) {\n      gmaps_place_id\n      cp_code\n      type\n    }\n  }\n"
    ]);
    _templateObject23 = function() {
        return data;
    };
    return data;
}
function _templateObject24() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query getTopSellingProductsByStore($storeId: String!) {\n    getTopSellingProductsByStore(storeId: $storeId) {\n      sku\n      name\n      price\n      dora_stock\n      hoskote_stock\n      skd_stock\n      west_zone_stock\n    }\n  }\n"
    ]);
    _templateObject24 = function() {
        return data;
    };
    return data;
}

const REQUEST_CALLBACK = (0,lib/* gql */.Ps)(_templateObject());
const GET_IN_TOUCH = (0,lib/* gql */.Ps)(_templateObject1());
const REQUEST_QUOTE = (0,lib/* gql */.Ps)(_templateObject2());
const others_GET_INVESTORS = (0,lib/* gql */.Ps)(_templateObject3());
const others_GET_CMS_PAGES = (0,lib/* gql */.Ps)(_templateObject4());
const others_GET_MEDIA = (0,lib/* gql */.Ps)(_templateObject5());
const others_GET_LATEST_NEWS = (0,lib/* gql */.Ps)(_templateObject6());
const CONTACT_US = (0,lib/* gql */.Ps)(_templateObject7());
const others_VIEW_PRESS_RELEASE = (0,lib/* gql */.Ps)(_templateObject8());
const others_VIEW_ANNOCEMNT = (0,lib/* gql */.Ps)(_templateObject9());
const SCHEDULE_MEETING = (0,lib/* gql */.Ps)(_templateObject10());
const others_URL_RESOLVER = (0,lib/* gql */.Ps)(_templateObject11());
const GET_AWARDS_AND_ACCOLADES = (0,lib/* gql */.Ps)(_templateObject12());
const GET_CSR_GALLERY = (0,lib/* gql */.Ps)(_templateObject13());
const GET_BOARD_OF_DIRECTORS_DATA = (0,lib/* gql */.Ps)(_templateObject14());
const GET_LEADERSHIP_TEAM_DATA = (0,lib/* gql */.Ps)(_templateObject15());
const PREMIUM_SALES_PRODUCT_LIST = (0,lib/* gql */.Ps)(_templateObject16());
const others_STORE_LOCATOR_SEND_SMS = (0,lib/* gql */.Ps)(_templateObject17());
const TILE_SELECTOR = (0,lib/* gql */.Ps)(_templateObject18());
const others_GETPRODUCTBYSKU = (0,lib/* gql */.Ps)(_templateObject19());
const others_GETSTATESCITIES = (0,lib/* gql */.Ps)(_templateObject20());
const others_GET_STORE_DATA = (0,lib/* gql */.Ps)(_templateObject21());
const others_GETNONOBTB = (0,lib/* gql */.Ps)(_templateObject22());
const others_GET_PLACE_DETAILS_BY_URL_KEY = (0,lib/* gql */.Ps)(_templateObject23());
const others_GET_PRODUCT_STORES_PAGE = (0,lib/* gql */.Ps)(_templateObject24());

// EXTERNAL MODULE: ./graphqlClient.js
var graphqlClient = __webpack_require__(33119);
// EXTERNAL MODULE: ./config.js
var config = __webpack_require__(83346);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var dist_lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./gtag.js
const GA_TRACKING_ID = "AW-811813558/RP2BCNnuqZoBELaVjYMD"; // Replace with your Tracking ID
const pageview = (url)=>{
    if (true) {
        window.gtag("config", GA_TRACKING_ID, {
            page_path: url
        });
    }
};
const gtag_event = (param)=>{
    let { action , category , label , value  } = param;
    if (true) {
        window.gtag("event", action, {
            event_category: category,
            event_label: label,
            value: value
        });
    }
};
const trackProductUnavailability = (productName, pinCode)=>{
    if ( true && window.gtag) {
        window.gtag("event", "product_unavailability", {
            event_category: "Product Interaction",
            event_label: "Product Unavailable: ".concat(productName, " - Pin Code: ").concat(pinCode)
        });
    }
};
const gtagConversionEvent = ()=>{
    window.gtag("event", "conversion", {
        // event_category: category,
        // event_label: label,
        value: 1
    });
};
const gtag_getBrowserName = ()=>{
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("chrome") > -1) return "Chrome";
    if (userAgent.indexOf("firefox") > -1) return "Firefox";
    if (userAgent.indexOf("safari") > -1 && userAgent.indexOf("chrome") === -1) return "Safari";
    if (userAgent.indexOf("msie") > -1 || userAgent.indexOf("trident") > -1) return "Internet Explorer";
    if (userAgent.indexOf("edge") > -1) return "Edge";
    return "Unknown";
};

;// CONCATENATED MODULE: ./api.services.js/others.js






let savePincode = async (variables)=>{
    try {
        let response = await axios/* default.post */.Z.post("".concat(config/* default.PROXY_SERVER_ENDPOINT */.Z.PROXY_SERVER_ENDPOINT, "/rest/V1/pincodedetails"), variables);
        return response;
    } catch (error) {
        return error;
    }
};
let requestCallback = async (variables)=>{
    let options = {
        mutation: REQUEST_CALLBACK,
        variables: {
            ...variables,
            page_url: (JSON.parse(localStorage.getItem("visitedPages")) || []).slice(-10).join(" => "),
            First_Visited_URL: JSON.parse(localStorage.getItem("firstVistedPage")),
            User_Browser: gtag_getBrowserName(),
            User_Device: dist_lib/* isMobile */.tq ? "Mobile" : "Desktop"
        }
    };
    try {
        let response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
let getIntouch = async (variables)=>{
    let options = {
        mutation: GET_IN_TOUCH,
        variables: {
            ...variables,
            page_url: (JSON.parse(localStorage.getItem("visitedPages")) || []).slice(-10).join(" => "),
            First_Visited_URL: JSON.parse(localStorage.getItem("firstVistedPage")),
            call_id: variables.call_id ? variables.call_id : "Get In Touch",
            User_Browser: gtag_getBrowserName(),
            User_Device: dist_lib/* isMobile */.tq ? "Mobile" : "Desktop"
        }
    };
    try {
        let response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
let requestQuote = async (variables)=>{
    let options = {
        mutation: REQUEST_QUOTE,
        variables: {
            ...variables,
            User_Browser: gtag_getBrowserName(),
            User_Device: dist_lib/* isMobile */.tq ? "Mobile" : "Desktop"
        }
    };
    try {
        let response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
let getInvestors = async (variables)=>{
    let options = {
        query: GET_INVESTORS,
        variables: variables
    };
    try {
        let response = await client.query(options);
        return response;
    } catch (error) {
        return error;
    }
};
let GetCmsPages = async (variables)=>{
    let options = {
        query: GET_CMS_PAGES,
        variables: variables
    };
    try {
        let response = await client.query(options);
        return response;
    } catch (error) {
        return error;
    }
};
let getMedia = async (variables)=>{
    let options = {
        query: GET_MEDIA,
        variables: variables,
        fetchPolicy: "no-cache"
    };
    try {
        let response = await client.query(options);
        return response;
    } catch (error) {
        return error;
    }
};
let getLatestNews = async (variables)=>{
    let options = {
        query: GET_LATEST_NEWS,
        variables: variables,
        fetchPolicy: "no-cache"
    };
    try {
        let response = await client.query(options);
        return response;
    } catch (error) {
        return error;
    }
};
let contactUs = async (variables)=>{
    let options = {
        mutation: CONTACT_US,
        variables: {
            ...variables,
            pageurl: (JSON.parse(localStorage.getItem("visitedPages")) || []).slice(-10).join(" => "),
            First_Visited_URL: JSON.parse(localStorage.getItem("firstVistedPage")),
            User_Browser: gtag_getBrowserName(),
            User_Device: dist_lib/* isMobile */.tq ? "Mobile" : "Desktop"
        }
    };
    try {
        let response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
let viewPressRelease = async (variables)=>{
    let options = {
        query: VIEW_PRESS_RELEASE,
        variables: variables
    };
    try {
        let response = await client.query(options);
        return response;
    } catch (error) {
        return error;
    }
};
let viewAnnoucement = async (variables)=>{
    let options = {
        query: VIEW_ANNOCEMNT,
        variables: variables
    };
    try {
        let response = await client.query(options);
        return response;
    } catch (error) {
        return error;
    }
};
let scheduleMeeting = async (variables)=>{
    let options = {
        mutation: SCHEDULE_MEETING,
        variables: {
            ...variables,
            page_url: (JSON.parse(localStorage.getItem("visitedPages")) || []).slice(-10).join(" => "),
            First_Visited_URL: JSON.parse(localStorage.getItem("firstVistedPage")),
            User_Browser: gtag_getBrowserName(),
            User_Device: dist_lib/* isMobile */.tq ? "Mobile" : "Desktop"
        }
    };
    try {
        let response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
let urlResolver = async (variables)=>{
    let options = {
        query: URL_RESOLVER,
        variables: variables
    };
    try {
        let response = await client.query(options);
        return response;
    } catch (error) {
        return error;
    }
};
let getAwardsAndAccolades = async (variables)=>{
    let options = {
        query: GET_AWARDS_AND_ACCOLADES,
        variables: variables
    };
    try {
        let response = await graphqlClient/* default.query */.Z.query(options);
        return response;
    } catch (err) {
        return err;
    }
};
let getCsrGallery = async (variables)=>{
    let options = {
        query: GET_CSR_GALLERY,
        variables: variables
    };
    try {
        let response = await graphqlClient/* default.query */.Z.query(options);
        return response;
    } catch (err) {
        return err;
    }
};
let getBoardOfDirectorsData = async (variables)=>{
    let options = {
        query: GET_BOARD_OF_DIRECTORS_DATA,
        variables: variables
    };
    try {
        let response = await graphqlClient/* default.query */.Z.query(options);
        return response;
    } catch (err) {
        return err;
    }
};
let getLeadershipTeamData = async (variables)=>{
    let options = {
        query: GET_LEADERSHIP_TEAM_DATA,
        variables: variables
    };
    try {
        let response = await graphqlClient/* default.query */.Z.query(options);
        return response;
    } catch (err) {
        return err;
    }
};
let getPremiumSalesListing = async (variables)=>{
    let options = {
        mutation: PREMIUM_SALES_PRODUCT_LIST,
        variables: variables
    };
    try {
        let response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
let storeLocatorSendSms = async (variables)=>{
    let options = {
        mutation: STORE_LOCATOR_SEND_SMS,
        variables: {
            ...variables,
            User_Browser: getBrowserName(),
            User_Device: isMobile ? "Mobile" : "Desktop"
        }
    };
    try {
        let response = await client.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
let TileSelectorApi = async (variables)=>{
    let options = {
        mutation: TILE_SELECTOR,
        variables: variables,
        fetchPolicy: "no-cache"
    };
    try {
        let response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
let getProductDetailsBySkuQuery = async (variables)=>{
    let options = {
        mutation: GETPRODUCTBYSKU,
        variables: variables,
        fetchPolicy: "no-cache"
    };
    try {
        let response = await client.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
let GetStoreData = async (variables)=>{
    let options = {
        query: GET_STORE_DATA,
        variables: variables
    };
    try {
        let response = await client.query(options);
        return response;
    } catch (err) {
        return err;
    }
};
let getStatesCities = async (variables)=>{
    let options = {
        query: GETSTATESCITIES,
        variables: variables
    };
    try {
        let response = await client.query(options);
        return response;
    } catch (error) {
        return error;
    }
};
let getNonObtb = async (variables)=>{
    let options = {
        query: GETNONOBTB,
        variables: variables
    };
    try {
        let response = await client.query(options);
        return response;
    } catch (error) {
        return error;
    }
};
let GetPlaceDetailsByUrlKey = async (variables)=>{
    let options = {
        query: GET_PLACE_DETAILS_BY_URL_KEY,
        variables: variables
    };
    try {
        let response = await client.query(options);
        return response;
    } catch (err) {
        return err;
    }
};
let GetProductsOnStorePage = async (variables)=>{
    let options = {
        query: GET_PRODUCT_STORES_PAGE,
        variables: variables
    };
    try {
        let response = await client.query(options);
        return response;
    } catch (err) {
        return err;
    }
};


/***/ }),

/***/ 33119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61680);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24145);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38067);

// // enable cors
// var corsOptions = {
//     origin: true,
//     credentials: true // <-- REQUIRED backend setting
//   };
//   app.use(cors(corsOptions));
const headers = {
    "Access-Control-Allow-Origin": "*"
};
const httpLink = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .createHttpLink */ .L)({
    uri: "http://orientbell.com/graphql"
});
const client = new _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .ApolloClient */ .f({
    //link: headers.concat(httpLink),
    uri: "https://obl-js.orientbell.com/",
    cache: new _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .InMemoryCache */ .h(),
    fetchOptions: {
        mode: "no-cors"
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (client);


/***/ })

}]);